import React, { useEffect, useState } from 'react';
import ChestnyZnakInfoBlock from '../ChestnyZnakInfoBlock';
import {
  fetchGetAccountingAttributes,
  fetchAddAccountingAttribute,
} from '../../../../actions/items';
import { POSSIBLE_MASKS } from '../../../../helpers';
import Checkbox from '../../../common/Checkbox';
import Select from '../../../common/Select';
import { useDispatch } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';
import { toast } from 'react-toastify';
import InputWrapper from '../../../common/InputWrapper';
import QuantityPicker from '../../../common/QuantityPicker';
import QuestionMark from '../../../common/QuestionMark';
import Button from '../../../common/Button';

const UniqueNumbersBlock = (props) => {
  const { product, variant, values, handleChangeInput, setLoading, showModal } = props;

  const dispatch = useDispatch();

  const [showAccountingAttributes, setShowAccountingAttributes] = useState(false);
  const [currentMasks, setCurrentMasks] = useState('');
  const [isRegExpValid, setIsRegExpValid] = useState({});
  const [accountingAttributes, setAccountingAttributes] = useState([]);
  const actualAccountingAttributes = accountingAttributes
    ? accountingAttributes.map((a) => ({ value: a.code, label: a.title }))
    : [];
  const newAccountingAttributesForAdding =
    values.accountingAttributes && values.accountingAttributes.filter((a) => !a.code);

  // Монокороба - УИТ
  useEffect(() => {
    if (
      !showAccountingAttributes &&
      values.accountingAttributes &&
      values.accountingAttributes.length
    ) {
      setShowAccountingAttributes(true);
    }
  }, [values.accountingAttributes]);

  // Монокороба - УИТ
  useEffect(() => {
    (async function () {
      setLoading(true);
      const newAccountingAttributes = await dispatch(fetchGetAccountingAttributes());
      setAccountingAttributes(newAccountingAttributes);
      // setCountries(countriesFromRedux.map((c) => ({ label: c.rusName, value: c.code })));
      setLoading(false);
    })();
  }, []);

  //Монокороба - УИТ start
  const defineDefaultMaskType = (attributeStringValue, idx, attributeCode) => {
    if (!attributeStringValue) return null;
    if (currentMasks[idx]) return currentMasks[idx];

    if (attributeStringValue.includes('{УИТ}')) {
      setCurrentMasks({
        ...currentMasks,
        [idx]: POSSIBLE_MASKS[0],
      });
      return POSSIBLE_MASKS[0];
    }

    if (
      attributeStringValue.includes('/') ||
      attributeStringValue.includes('\\') ||
      attributeStringValue.includes('@') ||
      attributeStringValue.includes('+') ||
      attributeStringValue.includes('*') ||
      attributeStringValue.includes('[') ||
      attributeStringValue.includes('(') ||
      attributeStringValue.includes('{') ||
      attributeStringValue.includes('$')
    ) {
      setCurrentMasks({
        ...currentMasks,
        [idx]: POSSIBLE_MASKS[2],
      });
      return POSSIBLE_MASKS[2];
    }

    if (attributeStringValue.includes('?')) {
      setCurrentMasks({
        ...currentMasks,
        [idx]: POSSIBLE_MASKS[1],
      });
      return POSSIBLE_MASKS[1];
    }

    setCurrentMasks({
      ...currentMasks,
      [idx]: { value: 'type_undefined', label: 'Тип маски не определён!' },
    });
    return { value: 'type_undefined', label: 'Тип маски не определён!' };
  };

  const handleChangeMask = (option, idx) => {
    setCurrentMasks({
      ...currentMasks,
      [idx]: option,
    });

    if (option.value === POSSIBLE_MASKS[0].value) {
      handleAccountingAttributeValueChange('{УИТ}', idx);
    }
  };

  const handleAccountingAttributeValueChange = (value, index) => {
    const newAccountingAttributes = values.accountingAttributes.slice();
    newAccountingAttributes[index].stringValue = value;
    handleChangeInput('accountingAttributes', newAccountingAttributes);
  };

  const handleLengthCheckMaskValue = (currentValue, idx, min, max) => {
    if (currentValue < min) currentValue = min;
    if (currentValue > max) currentValue = max;

    let convertedValue = convertNumberToQuestionSignsQty(currentValue);
    handleAccountingAttributeValueChange(convertedValue, idx);
  };

  const convertNumberToQuestionSignsQty = (number) => {
    let questions = '';
    for (let i = 0; i < number; i++) {
      questions += '?';
    }
    return questions;
  };

  const convertQuestionSignsQtyToNumber = (signs, idx) => {
    if (!signs) {
      handleLengthCheckMaskValue(1, idx);
      return 1;
    } else {
      return signs.length;
    }
  };

  const handleRegExpMaskValue = (currentValue, idx, attributeCode) => {
    const key = attributeCode + idx;

    isRegularExpressionValid(currentValue)
      ? handleRegExpValidStatus(true, key)
      : handleRegExpValidStatus(false, key);

    handleAccountingAttributeValueChange(currentValue, idx);
  };

  const handleRemoveAccountingAttribute = (index) => {
    const newAccountingAttributes = values.accountingAttributes.slice();
    newAccountingAttributes.splice(index, 1);
    handleChangeInput('accountingAttributes', newAccountingAttributes);
  };

  const handleSetNewAccountingAttribute = (data) => {
    let currentAttribute = null;
    const isNewAttribute = data.__isNew__;

    if (isNewAttribute) {
      currentAttribute = {
        id: uuidv4(),
        code: true,
        values: [],
        title: data.label,
      };
      dispatch(
        showModal('EditAccountingAttribute', {
          attribute: currentAttribute,
          submitCallback: async (newData) => {
            currentAttribute = newData;
            await fetchNewAccountingAttribute(currentAttribute);
            updateAttributes(currentAttribute);
          },
        }),
      );
      return false;
    } else {
      const attributeId = data.value;
      currentAttribute =
        accountingAttributes && accountingAttributes.find((f) => f.code === attributeId);
    }

    if (currentAttribute) {
      updateAttributes(currentAttribute);
    }

    function updateAttributes(currentAttribute) {
      const newAccountingAttributes = values.accountingAttributes.slice();
      newAccountingAttributes[newAccountingAttributes.length - 1] = {
        ...currentAttribute,
        values: currentAttribute.values || [],
        isNew: true,
      };
      handleChangeInput('accountingAttributes', newAccountingAttributes);
    }
  };

  const isRegularExpressionValid = (regexp) => {
    if (regexp === '*') return true;
    if (regexp === '{УИТ}') return false;

    const reg = '/' + regexp + '/';
    try {
      const m = reg.match(/^([/~@;%#'])(.*?)\1([gimsuy]*)$/);
      return m ? Boolean(new RegExp(m[2], m[3]) || new RegExp(regexp)) : false;
    } catch (e) {
      return false;
    }
  };

  const handleRegExpValidStatus = (isValid, idx) => {
    setIsRegExpValid({
      ...isRegExpValid,
      [idx]: isValid,
    });
  };

  const fetchNewAccountingAttribute = (attribute) => {
    const newAttribute = Object.assign({}, attribute);
    newAttribute.values = [];
    return dispatch(fetchAddAccountingAttribute(newAttribute)).then((result) => {
      toast.info(`Атрибут "${result.code}" успешно добавлен`);
    });
  };

  const defineRegExpValidStatus = (value, idx, attributeCode) => {
    const key = attributeCode + idx;
    if (isRegExpValid.hasOwnProperty(key)) return;

    const isValid = isRegularExpressionValid(value);
    handleRegExpValidStatus(isValid, key);
    return isValid;
  };

  const handleAddAccountingAttribute = () => {
    const newAccountingAttributes = (
      values.accountingAttributes ? values.accountingAttributes : []
    ).slice();
    newAccountingAttributes.push({});
    handleChangeInput('accountingAttributes', newAccountingAttributes);
  };
  //Монокороба УИТ - end

  return (
    <>
      <div className="row">
        <div className="col-12">
          <Checkbox
            label="Добавить учет по уникальным номерам монокороба"
            id={'showAccountingAttributes'}
            // inputClass="admin-checkbox-bg-color fe-help-circle"
            checked={showAccountingAttributes}
            onChange={() => setShowAccountingAttributes(true)}
          />
        </div>
      </div>

      {showAccountingAttributes ? (
        <>
          <div className="row">
            <div className="col-12" style={{ display: 'flex', marginTop: '35px' }}>
              <h4 className="header-title" style={{ marginBottom: '7px' }}>
                Учёт товара по уникальным номерам при отгрузке монокороба
              </h4>
            </div>
          </div>

          {values?.accountingAttributes?.map((attribute, i) =>
            attribute.code ? (
              <div className="row attribute-row" key={`accounting-attribute-${i}`}>
                {attribute.code ? (
                  <>
                    <div className="col-3 title-block" style={{ maxWidth: '145px' }}>
                      <div style={{ fontWeight: 500 }}>
                        {(accountingAttributes.find((f) => f.code === attribute.code) || {}).title}
                      </div>
                      <div>{attribute.code}</div>
                    </div>
                    <div className="col-8 tags-block">
                      <div className="form-group" style={{ marginTop: '10px', marginBottom: 0 }}>
                        <div>
                          <Select
                            options={POSSIBLE_MASKS}
                            defaultValue={defineDefaultMaskType(
                              attribute.stringValue,
                              i,
                              attribute.code,
                            )}
                            onChange={(option) => handleChangeMask(option, i)}
                            placeholder="Выберите маску..."
                          />
                          {currentMasks && currentMasks[i] ? (
                            <>
                              {currentMasks[i].value === 'type_undefined' && (
                                <InputWrapper
                                  type="text"
                                  value={attribute.stringValue}
                                  placeholder="Введите значение"
                                  maxLength="50"
                                  readOnly="true"
                                />
                              )}
                              {currentMasks[i].value === POSSIBLE_MASKS[1].value && (
                                <QuantityPicker
                                  className="w-25 mt-2"
                                  value={convertQuestionSignsQtyToNumber(attribute.stringValue, i)}
                                  onChange={(value) => handleLengthCheckMaskValue(value, i, 1, 200)}
                                  min={1}
                                  max={200}
                                  reverse
                                />
                              )}
                              {currentMasks[i].value === POSSIBLE_MASKS[2].value && (
                                <div className="d-flex align-items-center mt-2 mb-2">
                                  <InputWrapper
                                    type="text"
                                    noLabel
                                    value={attribute.stringValue}
                                    onChange={(e) =>
                                      handleRegExpMaskValue(e.target.value, i, attribute.code)
                                    }
                                    placeholder="Укажите регулярное выражение"
                                    maxLength="200"
                                  />
                                  {attribute?.stringValue?.length > 0 &&
                                  (defineRegExpValidStatus(
                                    attribute?.stringValue,
                                    i,
                                    attribute.code,
                                  ) ||
                                    !isRegExpValid[`${attribute.code + i}`]) ? (
                                    <span className="error-invalid">
                                      Регулярное выражение не валидно!
                                    </span>
                                  ) : null}
                                  <QuestionMark hint="Укажите регулярное выражение" />
                                </div>
                              )}
                            </>
                          ) : null}
                        </div>
                      </div>
                    </div>
                    <div
                      className="col-1 removing-block"
                      style={{ display: 'flex', paddingRight: '0' }}
                    >
                      <Button
                        style={{ marginLeft: 'auto' }}
                        classType="btn-link"
                        type="button"
                        text={
                          <i
                            className="fe-trash-2"
                            style={{ color: '#6c757d', fontSize: '20px' }}
                          />
                        }
                        onClick={() => handleRemoveAccountingAttribute(i)}
                      />
                    </div>
                  </>
                ) : null}
              </div>
            ) : null,
          )}

          {newAccountingAttributesForAdding
            ? newAccountingAttributesForAdding.map((attribute, i) => (
                <div className="row attribute-row" key={`new-attribute-${i}`}>
                  <div className="col-12" style={{ paddingLeft: '0' }}>
                    <div className="form-group" style={{ maxWidth: '250px', margin: '10px 0' }}>
                      <Select
                        isCreatable
                        placeholder="Введите имя атрибута..."
                        options={actualAccountingAttributes}
                        value={
                          attribute.title
                            ? { value: attribute.code, label: attribute.title }
                            : undefined
                        }
                        menuPortalTarget={document.querySelector('body')}
                        onChange={(data) => handleSetNewAccountingAttribute(data, i)}
                      />
                    </div>
                  </div>
                </div>
              ))
            : null}

          <div className="row add-option-button-row">
            <div
              className="col-12"
              style={{
                paddingLeft:
                  values.accountingAttributes && values.accountingAttributes.length ? 0 : '12px',
              }}
            >
              <button
                type="button"
                className="btn btn-sm btn-light mb-2"
                onClick={handleAddAccountingAttribute}
              >
                <i className="fe-plus" /> Добавить
              </button>
              <ChestnyZnakInfoBlock
                handleChangeInput={handleChangeInput}
                allowSkipCis={values.allowSkipCis}
                currentProductVariants={product?.variants}
                currentProductId={product?.id}
                isProductPage={true}
                variantId={variant.id}
              />
            </div>
          </div>
        </>
      ) : null}
    </>
  );
};

export default UniqueNumbersBlock;
